"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRolEchainWithoutAdditionalLinkUnsafe = exports.isRolEchainWithoutAdditionalLink = exports.rolEchainWithoutAdditionalLinkUseableDef = exports.isRolEchainWithAutoglideLinkUnsafe = exports.isRolEchainWithAutoglideLink = exports.rolEchainWithAutoglideLinkUseableDef = exports.isRolEchainWithModifiedLinkUnsafe = exports.isRolEchainWithModifiedLink = exports.rolEchainWithModifiedLinkUseableDef = exports.isRolEchainWithAdapterLinkUnsafe = exports.isRolEchainWithAdapterLink = exports.rolEchainWithAdapterLinkUseableDef = exports.isRolEchainBaseUnsafe = exports.isRolEchainBase = exports.rolEchainBaseUseableDef = void 0;
const RolAdapterLink_1 = require("../link/RolAdapterLink");
const RolAutoglideLink_1 = require("../link/RolAutoglideLink");
const RolLink_1 = require("../link/RolLink");
const RolModifiedLink_1 = require("../link/RolModifiedLink");
const StandardLink_1 = require("../link/StandardLink");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const KetteSerieType_1 = require("../kette/KetteSerieType");
const schemaVersions_1 = require("../schemaVersions");
const RolEchainSeries_1 = require("./RolEchainSeries");
exports.rolEchainBaseUseableDef = {
    parent: schemaVersions_1.ketteLatestUseableDef,
    validation: {
        Aussenbreite: true,
        Aussenhoehe: true,
        Bauform: true,
        Biegeradius: true,
        Innenbreite: true,
        Innenhoehe: true,
        K2: true,
        KetteSerieType: (v) => v === KetteSerieType_1.KetteSerieType.rolEchain,
        LeitungDiameterMax: true,
        RolLink: (link) => (0, RolLink_1.isRolLink)(link),
        Serie: RolEchainSeries_1.isRolEchainSeries,
        StandardLink: (link) => (0, StandardLink_1.isStandardLink)(link),
    },
    unsafeValidation: {
        KetteSerieType: (v) => v === KetteSerieType_1.KetteSerieType.rolEchain,
    },
};
exports.isRolEchainBase = echain_shared_modelling_1.UseableUtil.createGuard(exports.rolEchainBaseUseableDef);
exports.isRolEchainBaseUnsafe = echain_shared_modelling_1.UseableUtil.createUnsafeGuard(exports.rolEchainBaseUseableDef);
exports.rolEchainWithAdapterLinkUseableDef = {
    parent: exports.rolEchainBaseUseableDef,
    validation: {
        AdapterLink: (link) => (0, RolAdapterLink_1.isRolAdapterLink)(link),
        AutoglideLink: false,
        ModifiedLink: false,
    },
    unsafeValidation: {
        AdapterLink: true,
    },
};
exports.isRolEchainWithAdapterLink = echain_shared_modelling_1.UseableUtil.createGuard(exports.rolEchainWithAdapterLinkUseableDef);
exports.isRolEchainWithAdapterLinkUnsafe = echain_shared_modelling_1.UseableUtil.createUnsafeGuard(exports.rolEchainWithAdapterLinkUseableDef);
exports.rolEchainWithModifiedLinkUseableDef = {
    parent: exports.rolEchainBaseUseableDef,
    validation: {
        AdapterLink: false,
        AutoglideLink: false,
        ModifiedLink: (link) => (0, RolModifiedLink_1.isRolModifiedLink)(link),
    },
    unsafeValidation: {
        ModifiedLink: true,
    },
};
exports.isRolEchainWithModifiedLink = echain_shared_modelling_1.UseableUtil.createGuard(exports.rolEchainWithModifiedLinkUseableDef);
exports.isRolEchainWithModifiedLinkUnsafe = echain_shared_modelling_1.UseableUtil.createUnsafeGuard(exports.rolEchainWithModifiedLinkUseableDef);
exports.rolEchainWithAutoglideLinkUseableDef = {
    parent: exports.rolEchainBaseUseableDef,
    validation: {
        AdapterLink: false,
        AutoglideLink: (link) => (0, RolAutoglideLink_1.isRolAutoglideLink)(link),
        ModifiedLink: false,
    },
    unsafeValidation: {
        AutoglideLink: true,
    },
};
exports.isRolEchainWithAutoglideLink = echain_shared_modelling_1.UseableUtil.createGuard(exports.rolEchainWithAutoglideLinkUseableDef);
exports.isRolEchainWithAutoglideLinkUnsafe = echain_shared_modelling_1.UseableUtil.createUnsafeGuard(exports.rolEchainWithAutoglideLinkUseableDef);
exports.rolEchainWithoutAdditionalLinkUseableDef = {
    parent: exports.rolEchainBaseUseableDef,
    validation: {
        AdapterLink: false,
        AutoglideLink: false,
        ModifiedLink: false,
    },
    unsafeValidation: {
        AdapterLink: false,
        AutoglideLink: false,
        ModifiedLink: false,
    },
};
exports.isRolEchainWithoutAdditionalLink = echain_shared_modelling_1.UseableUtil.createGuard(exports.rolEchainWithoutAdditionalLinkUseableDef);
exports.isRolEchainWithoutAdditionalLinkUnsafe = echain_shared_modelling_1.UseableUtil.createUnsafeGuard(exports.rolEchainWithoutAdditionalLinkUseableDef);
//# sourceMappingURL=RolEchain.js.map